export const usersReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET':
      localStorage.setItem('user', JSON.stringify(payload));
      return payload;
    case 'GET':
      return JSON.parse(localStorage.getItem('user'));
    case 'UPDATE_VIEWS':
      const updatedUser = { ...state, views: payload };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;

    case 'SET_FAVOURITE_MENU': {
      const updatedFavouriteMenus = Array.isArray(payload) ? payload : [...(state.favouriteMenu || []), payload];

      const updatedUser = {
        ...state,
        favouriteMenu: updatedFavouriteMenus,
      };

      localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;
    }

    case 'UPDATE_FAVOURITE_MENU': {
      const updatedFavouriteMenus = (state.favouriteMenu || []).map((menu) =>
        menu.id === payload.id ? payload : menu
      );

      const updatedUser = {
        ...state,
        favouriteMenu: updatedFavouriteMenus,
      };

      localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;
    }

    case 'DELETE_FAVOURITE_MENU': {
      const updatedFavouriteMenus = (state.favouriteMenu || []).filter((menu) => menu.id !== payload);

      const updatedUser = {
        ...state,
        favouriteMenu: updatedFavouriteMenus,
      };

      localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;
    }

    default:
      //throw new Error('Nincs ilyen eset a usersReducerben!');
      return state;
  }
};
